import { render, staticRenderFns } from "./JobColl.vue?vue&type=template&id=89c89188&scoped=true&"
import script from "./JobColl.vue?vue&type=script&lang=js&"
export * from "./JobColl.vue?vue&type=script&lang=js&"
import style0 from "./JobColl.vue?vue&type=style&index=0&id=89c89188&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c89188",
  null
  
)

export default component.exports